/**
 * Created by cc on 2016/10/20 0020.
 */
export default  {
    before : [
        'function(req , res , Flow , next){',
        '}'
    ]
}
module.exports = exports.default;